import { InstitutionService } from './../../../services/institution.service';
import { Component, OnInit } from '@angular/core';
import { CreateInstitutionModel } from '../../../models/inModels/Institution';
import { Message } from 'primeng/components/common/message';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { Router } from '@angular/router';
import { StorageService } from '../../../services/system/storage.service';

@Component({
  selector: 'app-create-institution',
  templateUrl: './create-institution.component.html',
  styleUrls: ['./create-institution.component.css']
})
export class CreateInstitutionComponent implements OnInit {
  model: CreateInstitutionModel;
  loading: boolean = false;
  error: Message[];
  uploading = false;
  constructor(
    public storageService: StorageService,
    private institutionService: InstitutionService,
    private router : Router,
  ) { 
    this.model = new CreateInstitutionModel();
  }

  ngOnInit() {
  }

  goBack(): void {
    this.router.navigate(['/institutions']);
  }

  handleImage(event): void {
		var result = this.storageService.handleSuccess(event);
		this.model.logoId = result.PublicId;
		this.loading = false;
	}

  save(): void {
    console.log(this.model);
    this.loading = true;
    this.institutionService.create(this.model).then(
      result => {
        this.loading = false;
        this.goBack();
      },
      error => {
        this.loading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }

  removeImage(): void {
		this.model.logoId = null;
		this.loading = false;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/institutions/create-institution/create-institution.component.ts